<ng-template [ngIf]="showSection">
<div *ngIf="!pane || !pane.loaded else contentBlock" class="new-content">
  <loading-line *ngIf="pane.display_mode === 'row'" height="40px" width="100%"></loading-line>
</div>

  <app-skeleton *ngIf="showSkeleton && pane.display_mode !== 'row'" [stats]="'my-classes-homework'"></app-skeleton>

  <ng-template #contentBlock>
    <div *ngIf="!showSkeleton" class="content" [class.cell-row]="pane.display_mode === 'row'">
    <app-chapter [link]="blockTitle?.add_link" [title]="blockTitle.title"></app-chapter>

    <app-filter-content (onSelect)="selectedTab = $event"
                        *ngIf="pane.display_mode !== 'col'"
                        [top]="isAsIfTeacher" [activeTab]="selectedTab" [tabs]="categoryTabs">
      <ng-template [ngIf]="isAsIfTeacher" action>
        <on-ui-button *ngIf="!deviceService.isMobile()"  (onclick)="onNewHomework()"
                      class="poutline"
                      label="my-classes.actions.new-homework">
        </on-ui-button>

        <div *ngIf="deviceService.isMobile()" class="create-item" (click)="onNewHomework()">
          <div class="action-icon-wrap">
            <app-icon [width]="10" [height]="10" icon="plus"></app-icon>
          </div>
        </div>
      </ng-template>
    </app-filter-content>

    <div *ngIf="false" [class.cell-row]="pane.display_mode === 'col'" class="homework">
      <app-homework-mini *ngFor="let work of subjects; trackBy: trackByFn"
                         [display_mode]="pane.display_mode"
                         [homework]="work">
      </app-homework-mini>
    </div>

    <app-empty *ngIf="showEmptyContent" [empty]="emptyContent"></app-empty>
    <ng-container *ngIf="pane.display_mode === 'row'" [ngTemplateOutlet]="noContentStub"></ng-container>
  </div>
</ng-template>

<ng-template #noContentStub>
  <app-no-content-stub
    [icon]="'stub-homework'"
    [text]="isAsIfTeacher ? 'my-classes.stub.stub4' : 'my-classes.stub.stub4_1'">
  </app-no-content-stub>
</ng-template>
</ng-template>
